import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { theme, breakpoint } from '../../theme';
import { LogoIcon } from '../../assets';
import { useBreakpointMap } from '../../utils';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacings[5].rem} ${theme.spacings[4].rem};
  ${breakpoint('md')`
      padding: ${theme.spacings[4].rem} ${theme.spacings[5].rem};     
    `}
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TopMenu: React.FC<
  PropsWithChildren<{
    className?: string;
    logolink?: string;
    onClick?: React.MouseEventHandler;
    isMobile?: boolean;
    categoryNavigator: React.ReactNode;
    isXmasLogo?: boolean;
    imgSrc?: string;
  }>
> = ({
  children,
  className,
  logolink,
  onClick,
  isMobile,
  categoryNavigator,
  isXmasLogo = false,
  imgSrc = 'https://res3.grays.com/handlers/imagehandler.ashx?t=cr&id=391691&s=d&index=0&ct=svg',
}) => {
  const viewportSize = useBreakpointMap({
    xs: 'Responsive',
    sm: 'tablet',
    md: 'Desktop',
  });
  const showCategoryNav =
    isMobile !== undefined ? isMobile : viewportSize !== 'Desktop';
  return (
    <Wrapper className={className}>
      <Container>
        {showCategoryNav && <div> {categoryNavigator} </div>}
        <a href={logolink} onClick={onClick}>
          {isXmasLogo ? (
            <img width="106px" alt="grays-xmas-logo" src={imgSrc}></img>
          ) : (
            <LogoIcon
              fill={theme.colors.primary.graysRed}
              width={106}
            ></LogoIcon>
          )}
        </a>
      </Container>
      <Container>{children}</Container>
    </Wrapper>
  );
};
